module.exports = __webpack_public_path__ + "components/flag/static/square/dz-872446b41131119455b8e32d7a88984d.svg";